import { setModal, setShowModal } from '.'
import { resetMenuState } from '../../app-state/state.menu'
import { EmojiViewerProps } from '../../components/presentation/Modals/Dialogs/EmojiViewer'
import {
    AGE_VERIFICATION,
    EMOJI_VIEWER,
    EMOJIS,
    GALLERY_ALBUM_IMAGE,
    HIDE_FLOATING_PLAYER,
    MENU,
    QUICKBUY,
    RULE_VIOLATION,
    WHITEBOARD,
} from '../../constants/dialogs'
import { ModalKind } from '../../constants/enums'
import { IUserImage } from '../../mfcLogic/api/chatImages'
import { MergedPrivateGalleryUser } from '../../mfcLogic/api/privateGallery'
import i18n from '../../utilities/i18n'

export const closeDialog = (immediate = false) => {
    // safeTransition(() => {
    resetMenuState()
    setShowModal(ModalKind.Dialog, false, immediate)
    // }, skipTransition)
    // setShowModal(ModalKind.Dialog, false, immediate)
}

export const openAgeVerificationDialog = () =>
    setModal(ModalKind.Dialog, {
        type: AGE_VERIFICATION,
        show: true,
        disableBackdropClick: true,
        expanded: true,
        close: false,
    })

export interface EmojiPickerProps {
    onInsertEmoticon(key: string): void
    onInsertImage(imageData: IUserImage): void
    showSearch?: boolean
    fullWindow?: boolean
}

export const openEmojiPicker = (props: EmojiPickerProps) =>
    setModal(ModalKind.Dialog, {
        ...props,
        type: EMOJIS,
        show: true,
        close: false,
    })

export const openHideFloatingPlayerDialog = () =>
    setModal(ModalKind.Dialog, {
        type: HIDE_FLOATING_PLAYER,
        show: true,
        title: i18n.t('settings.extraOptions.dialogTitle'),
        close: true,
    })

export const openModelMenuDialog = (
    slug: string,
    props: {
        hideNextPrev?: boolean
        message?: boolean
        noVideo?: boolean
        room?: boolean
    },
    immediate = true,
) =>
    setModal(
        ModalKind.Dialog,
        {
            ...props,
            slug,
            type: MENU,
            show: true,
        },
        { immediate },
    )

export const openEmojiViewerDialog = (props: EmojiViewerProps) => {
    const { type, emoji, shortcut } = props
    const title = type === 'e' ? 'View Emoji' : 'View Image'
    setModal(ModalKind.Dialog, {
        type: EMOJI_VIEWER,
        show: true,
        close: true,
        title,
        emoji,
        shortcut,
    })
}

interface GalleryDialogProps {
    currentPosition: number
    fullPage: boolean
    gallery: MergedPrivateGalleryUser
    galleries: Array<MergedPrivateGalleryUser>
    title: string
}

export const openGalleryImageDialog = (props: GalleryDialogProps) =>
    setModal(ModalKind.Dialog, {
        ...props,
        type: GALLERY_ALBUM_IMAGE,
        show: true,
    })

export const openQuickbuyDialog = () =>
    setModal(ModalKind.Dialog, { type: QUICKBUY, show: true })

export const openRuleViolationDialog = (props: { message: string }) => {
    const { message } = props
    setModal(ModalKind.Dialog, {
        type: RULE_VIOLATION,
        message: message,
        disableBackdropClick: true,
        expanded: true,
        close: false,
        fullPage: true,
        show: true,
    })
}

export const openWhiteboardDialog = (identifier: number | string) =>
    setModal(ModalKind.Dialog, {
        type: WHITEBOARD,
        identifier,
        fullHeight: true,
        show: true,
    })
